export const SALE_TYPE = {
  TODAY: 1,
  BID: 2,
  TOMMOROW: 3,
  AFTER_ONE_TOMMOROW: 4,
  AFTER_TWO_TOMMOROW: 5,
  PRE_SALE: 6,
  AFTERNOON: 7
}
